import React, { useEffect } from 'react';
import styles from '@/styles/ContactInformationComponent.module.scss';
import { OfficesComponent } from './OfficesComponent';
import { getCTAS } from '@/utils';
import { PEIHeadLine, PEISectionFooter, PEIScalableTable } from '@/common';
import { useAppContext } from '@/components/context';

type ContactInformationComponentProps = {
  institutionID: string;
  institutionName: string;
  officesCount: number;
  officesHQ: any;
  contacts: any;
  userType: string;
  contactsCount: number;
  partnerStatus: string;
};

export const ContactInformationComponent = ({
  institutionName,
  institutionID,
  officesCount,
  officesHQ,
  contacts,
  contactsCount,
  partnerStatus,
  userType,
}: ContactInformationComponentProps) => {
  const { dispatch } = useAppContext();

  useEffect(() => {
    dispatch({
      type: 'setRecordInfo',
      payload: {
        key: 'contacts',
        value: officesHQ.length > 0,
      },
    });
  }, [dispatch, officesHQ]);

  const data = contacts.map((contact: any) => {
    return [
      {
        text: `${contact.title?.name ? contact.title.name : ''} ${contact.givenName} ${
          contact.familyName
        }`.trim(),
        icon: 'user',
        keyContact: !!contact.keyContact,
      },
      { text: contact.jobTitle },
      {
        text: contact.basedAt.address
          ? `${contact.basedAt.address.city ? contact.basedAt.address.city.name + ',' : ''} ${
              contact.basedAt.address.country ? contact.basedAt.address.country.name : '-'
            } `
          : '-',
      },
      { text: contact.email, icon: 'lock' },
    ];
  });

  const allData = getCTAS(userType, institutionName, institutionID);
  const contactInformationComponentData: {
    ctaHeading?: string;
    LP: string;
    GP: string;
    'LP/GP': string;
  } = allData['ContactInformationComponent'];

  const ctas = {
    ctaLink: '',
  };

  switch (partnerStatus) {
    case 'LP':
      ctas.ctaLink = contactInformationComponentData.LP;
      break;
    case 'GP':
      ctas.ctaLink = contactInformationComponentData.GP;
      break;
    case 'LP/GP':
      ctas.ctaLink = contactInformationComponentData['LP/GP'];
      break;
  }

  return (
    <article className={styles.container} id='contacts'>
      <main className={styles['container-body']}>
        <PEIHeadLine text={`${institutionName} contact information`} />
        {officesHQ.length > 0 && (
          <OfficesComponent
            institutionName={institutionName}
            address={`${officesHQ[0].address.addressLine1}, ${
              officesHQ[0].address.city && officesHQ[0].address.city.name
            }, ${officesHQ[0].address.zipCode}, ${
              officesHQ[0].address.country.name && officesHQ[0].address.country.name
            }`}
            start={1}
            end={officesCount}
          />
        )}
        <PEIScalableTable
          title='Contacts'
          data={data}
          headers={['Name', 'Job title', 'Location', 'Email']}
          start={contacts.length}
          end={contactsCount}
          institutionName={institutionName}
          centerCells
        />
      </main>
      <PEISectionFooter
        textToShow={contactInformationComponentData.ctaHeading}
        link={ctas.ctaLink}
      />
    </article>
  );
};
